export enum MeasurementType {
    LabelId = 1,
    Packing = 2,
    Weight = 3,
    RFID = 4,
    WMAClient = 5,
    Custom = 6,
}
